import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"

/**
 * Stable action getters for schedule editor operations stored on the session ref.
 * Callers read the latest function at invocation time — no Bound propagation needed.
 */
export function useScheduleEditorActions() {
    const { draftId } = useScheduleEditorIds()
    const session = readScheduleEditorSession(draftId)

    return {
        pushUndo: session?.pushUndo,
        saveAmend: session?.saveAmend,
        deleteAmend: session?.deleteAmend,
        refreshAmends: session?.refreshAmends,
        flushDraftBeforeSave: session?.flushDraftBeforeSave,
        reloadAuthoringDraftFromServer: session?.reloadAuthoringDraftFromServer,
        notifyDraftEdited: session?.notifyDraftEdited,
        notifyDraftStructureChanged: session?.notifyDraftStructureChanged,
    }
}
